import { NsxModule } from '@nirvana/shared/dtos/types/policies/common';
import { SearchableKeyword } from '../../../../../../ui/gzSearchableAccordionsPanel/types';
import { translateFn } from '../../../../../../utils/translator.helper';
import { NsxSearchableKeywords } from './nsx.types';

export const NSX_DEFAULT_VALUE: NsxModule = {
  enabled: false,
  default: false,
};

export function getNsxSearchableKeywords(): {
  [type in NsxSearchableKeywords]: SearchableKeyword;
} {
  return {
    [NsxSearchableKeywords.Nsx]: {
      translatedLabel: translateFn('NSX'),
      label: 'NSX',
    },
  };
}
